export default __webpack_public_path__ + "static/media/cash.ad065c51.jpg";